"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var YoullEarnMsg_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/bonus-points/YoullEarnMsg"));
var earn_activity_header_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/earn/earn-activity-header"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var SignInWarningMessage_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/warning-message/SignInWarningMessage"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importStar(require("../../config/constants"));
var actions_1 = require("../../redux/reducers/activity/actions");
var actions_2 = require("../../redux/reducers/app/actions");
var actions_3 = require("../../redux/reducers/ledger/actions");
var actions_4 = require("../../redux/reducers/upload-content/actions");
var useActivityDetailsData_1 = require("../../shared/hooks/providers/useActivityDetailsData");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var styles_1 = __importDefault(require("./styles"));
var UploadContentScreen = function (_a) {
    var _b;
    var _c, _d;
    var classes = _a.classes, t = _a.t, identifier = _a.identifier;
    var _e = (0, react_1.useState)(false), activityComplete = _e[0], setActivityCompleted = _e[1];
    var _f = (0, react_1.useState)(false), fileError = _f[0], setFileError = _f[1];
    var _g = (0, react_1.useState)(false), uploading = _g[0], setUploading = _g[1];
    var _h = (0, react_1.useState)(), uploadProgress = _h[0], setUploadProgress = _h[1];
    var _j = (0, react_1.useState)({}), cancelToken = _j[0], setCancelToken = _j[1];
    var _k = (0, react_1.useState)(false), isCancelled = _k[0], setIsCancelled = _k[1];
    var _l = (0, react_1.useState)(''), errorMessage = _l[0], setErrorMessage = _l[1];
    var _m = (0, react_1.useState)(null), photo = _m[0], setPhoto = _m[1];
    var _o = (0, react_1.useState)(), imgSrc = _o[0], setImgSrc = _o[1];
    var _p = (0, react_1.useState)(null), content = _p[0], setContent = _p[1];
    var _q = (0, react_1.useState)(false), isConfigLoaded = _q[0], setIsConfigLoaded = _q[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, core_1.useTheme)();
    var activityId = identifier + '';
    var _r = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _r.isAuthenticated, isRestricted = _r.isRestricted;
    var navigateToActivities = (0, react_1.useCallback)(function (message) {
        var appNavigate = {
            action: 'ACTIVITIES',
            data: message
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }, []);
    var showInvalidError = (0, react_1.useCallback)(function () {
        navigateToActivities({
            message: t('activities.activityUnavailable'),
            type: 'warning',
            messageTimeout: 3000
        });
    }, [navigateToActivities, t]);
    var _s = (0, useActivityDetailsData_1.useActivityDetailsData)(activityId, isLoggedIn, showInvalidError), activity = _s.activity, initData = _s.initData;
    (0, useScrollToTop_1.useScrollToTop)();
    (0, react_1.useEffect)(function () {
        if (activityId.length > 0 && activity) {
            getUploadConfig(activity === null || activity === void 0 ? void 0 : activity.key);
        }
    }, [activity, activityId.length]);
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var redirectContactUs = function () {
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var onUploadContent = function () {
        if (!isLoggedIn) {
            redirectToLogin();
            return;
        }
        if (activity === null || activity === void 0 ? void 0 : activity.externalLink) {
            window.open(activity === null || activity === void 0 ? void 0 : activity.externalLink);
            dispatch((0, actions_1.credit)(activity.key, function () {
                initData();
                setActivityCompleted(true);
            }, function (e) {
                var _a, _b;
                dispatch((0, actions_2.showMessageBar)({
                    type: 'error',
                    message: ((_b = (_a = e === null || e === void 0 ? void 0 : e.payload) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.includes('invalidAccess'))
                        ? t('error.activity.invalidAccess')
                        : t('error.general'),
                    messageTimeout: 10000
                }));
            }));
        }
    };
    var onDismissEarnPointsModal = function () {
        var _a;
        framework_1.GoFwInternalInstance.onEarnActivity();
        if ((_a = activity === null || activity === void 0 ? void 0 : activity.frequencyCap) === null || _a === void 0 ? void 0 : _a.limitReached) {
            navigateToActivities();
        }
        else {
            setActivityCompleted(false);
        }
    };
    if (!activity) {
        return null;
    }
    var convertMegabyteToByte = function (value) { return 1024 * 1024 * value; };
    var onFileSelected = function (event) {
        var types = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml'];
        var selectedFiles = event.target.files;
        var selectPhoto = photo;
        var isFileErr = false;
        if (selectedFiles !== null && selectedFiles.length > 0) {
            var selectedFile_1 = selectedFiles[0];
            if (types.every(function (type) { return selectedFile_1.type !== type; }) ||
                selectedFile_1.size > convertMegabyteToByte(constants_1.default.UPLOAD_PHOTO_IMAGE_SIZE)) {
                isFileErr = true;
                selectPhoto = null;
            }
            else {
                selectPhoto = selectedFile_1;
            }
            setFileError(isFileErr);
            setPhoto(selectPhoto);
            setIsCancelled(false);
            var reader_1 = new FileReader();
            reader_1.onloadend = function () {
                if (!!selectPhoto && reader_1.result) {
                    setImgSrc([reader_1.result]);
                }
                else {
                    setFileError(isFileErr);
                    setPhoto(null);
                    setIsCancelled(false);
                }
            };
            reader_1.readAsDataURL(selectedFile_1);
        }
    };
    var getUploadConfig = function (activityKey) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!!activityKey) return [3, 2];
                    return [4, (0, actions_4.getContentConfig)(activityKey).then(function (res) {
                            if (res) {
                                setContent(res);
                                setIsConfigLoaded(true);
                            }
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var validateResponse = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if (data && 'errorKey' in data && data.errorKey) {
                dispatch((0, actions_2.showMessageBar)({
                    message: data.errorKey,
                    type: 'error',
                    messageTimeout: 10000
                }));
                setErrorMessage((data === null || data === void 0 ? void 0 : data.errorKey) || 'Failed to Upload Photo');
            }
            else if ((_b = (_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.includes('FileSizeLimitExceededException')) {
                dispatch((0, actions_2.showMessageBar)({
                    message: t('error.error.media.fileTooBig'),
                    type: 'error',
                    messageTimeout: 5000
                }));
                setErrorMessage('Failed to Upload Photo');
            }
            else if (data) {
                if ('awarded' in data && data.awarded) {
                    setActivityCompleted(true);
                }
            }
            return [2];
        });
    }); };
    var onUploadPressed = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLoggedIn) {
                        redirectToLogin();
                        return [2];
                    }
                    setUploading(true);
                    setUploadProgress(0);
                    setIsCancelled(false);
                    setErrorMessage('');
                    if (!(!!content && !!photo)) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, (0, actions_4.uploadPhotoForActivity)(content.id.toString(), photo, cancelToken, onUploadProgress).then(function (data) { return validateResponse(data); })];
                case 2:
                    _a.sent();
                    dispatch((0, actions_3.fetchUserPoints)());
                    setUploading(false);
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Upload error:', error_1);
                    setErrorMessage((error_1 === null || error_1 === void 0 ? void 0 : error_1.errorKey) || 'Failed to Upload Photo');
                    setUploading(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var onCancelPressed = function () {
        if (cancelToken) {
            cancelToken.cancel();
            setIsCancelled(true);
        }
    };
    var onUploadProgress = function (progress) {
        var uploadProgress1 = Math.round((progress.loaded / progress.total) * 100);
        setUploadProgress(uploadProgress1);
    };
    var browseChangeButton = !uploading ? (react_1.default.createElement(core_1.Button, { variant: fileError || !imgSrc ? 'contained' : 'outlined', disabled: !isLoggedIn, color: "secondary", className: classes.button, component: "label" },
        react_1.default.createElement(core_1.Typography, { style: {
                color: fileError || !imgSrc ? theme.palette.common.white : theme.palette.text.secondary
            } }, fileError || !imgSrc ? 'Browse to Select' : 'Change Photo'),
        react_1.default.createElement("input", { type: "file", style: { display: 'none' }, accept: "image/*", onChange: onFileSelected }))) : null;
    var uploadButton = !uploading && !fileError && imgSrc ? (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: classes.button }),
        react_1.default.createElement(core_1.Button, { variant: "contained", color: "secondary", disabled: !isConfigLoaded, className: classes.button, onClick: onUploadPressed }, "Upload"))) : null;
    var uploadText = !uploading ? (react_1.default.createElement(core_1.Typography, { color: "error", className: classes.progressText }, fileError || !imgSrc ? '' : 'Click UPLOAD to earn points')) : null;
    var cancelButton = uploading ? (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.LinearProgress, { variant: "determinate", color: "secondary", value: uploadProgress }),
        react_1.default.createElement(core_1.Typography, { variant: "body2", color: "textPrimary", className: classes.progressText },
            uploadProgress,
            "% Uploaded"),
        react_1.default.createElement(core_1.Typography, { variant: "body2", color: "textPrimary", className: classes.pointsText }, "You will earn points once the upload finishes successfully"),
        react_1.default.createElement("div", { className: classes.button }),
        react_1.default.createElement(core_1.Button, { variant: "outlined", color: "secondary", className: classes.button, onClick: onCancelPressed }, isCancelled ? 'Cancelled' : 'Cancel'))) : null;
    var preview;
    if (!fileError && !!imgSrc) {
        preview = (react_1.default.createElement(core_1.CardMedia, { component: "img", image: imgSrc.toString(), className: classes.uploadedImg, title: "Preview of image to upload" }));
    }
    else {
        preview = (react_1.default.createElement(core_1.Typography, { variant: "body1", color: "textPrimary" }, "Select photo to preview"));
    }
    var selectGrid = (react_1.default.createElement(core_1.Grid, { className: classes.uploadGrid, container: true, spacing: 2 },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 6, className: classes.previewGridWrapper },
            !fileError && !!imgSrc ? (react_1.default.createElement(core_1.Grid, { className: classes.previewTextWrapper },
                react_1.default.createElement(core_1.Typography, { variant: "subtitle1", color: "textPrimary", className: classes.previewText },
                    ' ',
                    "Photo Preview",
                    ' '))) : null,
            react_1.default.createElement(core_1.Grid, { className: classes.previewGrid },
                react_1.default.createElement(core_1.Grid, null, preview))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 6, className: classes.selectGrid },
            fileError && (react_1.default.createElement("div", null,
                react_1.default.createElement(core_1.Typography, { variant: "body2", color: "error", className: classes.errorText },
                    react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "error.uploadPhoto.uploadError", components: { 1: react_1.default.createElement("br", null) } }, t('error.uploadPhoto.uploadError'))))),
            !isCancelled && errorMessage && isLoggedIn && (react_1.default.createElement(core_1.Typography, { variant: "body2", color: "error", className: classes.errorText }, t(errorMessage))),
            isCancelled && (react_1.default.createElement(core_1.Typography, { variant: "body2", color: "error", className: classes.cancelledText }, "Upload cancelled")),
            !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING') && (react_1.default.createElement(SignInWarningMessage_1.default, { onClick: onUploadContent })),
            browseChangeButton,
            uploadButton,
            uploadText,
            cancelButton,
            react_1.default.createElement("div", { className: (0, classnames_1.default)((_b = {}, _b[classes.centered] = true, _b[classes.pointsText] = true, _b)) },
                react_1.default.createElement(YoullEarnMsg_1.default, { noneBonusPoints: activity.amount, bonusPoints: activity.bonusAmount })))));
    var earnActivityHeader = (react_1.default.createElement(earn_activity_header_1.default, { data: {
            image: activity.imageUrl,
            title: activity.title,
            description: activity.description,
            points: activity.amount,
            preview_url: activity.videoUrl ? activity.videoUrl : undefined,
            isCoverImage: true
        }, hideBackBtn: true, bonusPoints: activity.bonusAmount ? activity.bonusAmount + activity.amount : 0, limitReached: isLoggedIn && !!((_c = activity === null || activity === void 0 ? void 0 : activity.frequencyCap) === null || _c === void 0 ? void 0 : _c.limitReached), onPress: onUploadContent, navigateTo: navigateToActivities, isRestricted: isLoggedIn && isRestricted, handleContactUs: redirectContactUs, renderContentGrid: selectGrid, showSignInWarning: !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING') }));
    return (react_1.default.createElement("div", { className: classes.container },
        activityComplete && (react_1.default.createElement(package_1.EarnPointsModal, { pointEarned: activity.amount + ((_d = activity.bonusAmount) !== null && _d !== void 0 ? _d : 0), isVisible: activityComplete, onClose: onDismissEarnPointsModal })),
        react_1.default.createElement(core_1.Grid, { className: classes.container, container: true, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, earnActivityHeader))));
};
exports.default = (0, react_i18next_1.withTranslation)()((0, core_1.withStyles)(styles_1.default)(UploadContentScreen));
//# sourceMappingURL=index.js.map